/** Client + SSR t() — defaults to bundled English, optional runtime override. */

import en from "../../../locales/en.json";

function flatten(obj, prefix = "", out = {}) {
  for (const [key, value] of Object.entries(obj || {})) {
    const path = prefix ? `${prefix}.${key}` : key;
    if (value && typeof value === "object" && !Array.isArray(value)) {
      flatten(value, path, out);
    } else if (typeof value === "string") {
      out[path] = value;
    }
  }
  return out;
}

const bundled = flatten(en);

function localeMap() {
  if (typeof window !== "undefined" && window.__GROWME_I18N__ && typeof window.__GROWME_I18N__ === "object") {
    return { ...bundled, ...window.__GROWME_I18N__ };
  }
  if (typeof globalThis !== "undefined" && globalThis.__GROWME_I18N__ && typeof globalThis.__GROWME_I18N__ === "object") {
    return { ...bundled, ...globalThis.__GROWME_I18N__ };
  }
  return bundled;
}

export function t(key, vars = {}) {
  const map = localeMap();
  let text = map[key] ?? key;
  for (const [name, value] of Object.entries(vars)) {
    text = text.replace(new RegExp(`\\{${name}\\}`, "g"), String(value));
  }
  return text;
}
